import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Ensures every route change starts at the top of the page.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
